// extracted by mini-css-extract-plugin
export default {"popover":"color-picker_popover__FTo4G","submit":"color-picker_submit__YcLIu"};